/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Last_Sign_In_OkInputs */

const fr_account_audit_last_sign_in_ok = /** @type {(inputs: Account_Audit_Last_Sign_In_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion récente`)
};

/**

* @param {Account_Audit_Last_Sign_In_OkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_last_sign_in_ok = /** @type {((inputs?: Account_Audit_Last_Sign_In_OkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Last_Sign_In_OkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_last_sign_in_ok(inputs)
});